import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { navData } from 'src/app/data/nav-data';
import { CommonService } from 'src/app/services/common.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'coaching-recommendation-actions',
  template: `
    <div class="recommendation-actions-container" fxLayout="row" fxLayoutAlign="start center">
      <button class="assign-btn" (click)="acceptCoaching()" mat-button vrm-button>
        {{ 'GENERIC.assign' | translate }}
      </button>
      <button class="reject-btn" (click)="rejectCoaching()" mat-button>{{ 'GENERIC.reject' | translate }}</button>
    </div>
  `,
  styles: [
    `
      .reject-btn.reject-btn {
        margin-right: 0;
        margin-left: 10px;
      }
    `,
  ],
})
export class CoachingRecommendationActionsComponent implements ICellRendererAngularComp {
  /**
   * The data for this row.
   */
  private rowData: any;

  /**
   * The intervention type for this report.
   */
  private interventionType: string;

  /**
   * Creates a new instance of CoachingRecommendationActionsComponent
   */
  constructor(private reportService: ReportsService, private cService: CommonService) {}

  /**
   * Executed on component initialization.
   */
  agInit(params: ICellRendererParams): void {
    this.rowData = params.data;
    this.interventionType = this.getInterventionType();
  }

  /**
   * Returns the intervention type.
   */
  getInterventionType(): string {
    let interventionType: string;

    const reportMeta = this.reportService.currentReportMeta;

    if (reportMeta.information && reportMeta.information.recommendationsReport) {
      interventionType = reportMeta.information.recommendationsReport.intervention;
    }

    return interventionType;
  }

  /**
   * Accepts the recommended coaching for this driver.
   */
  public acceptCoaching(): void {
    const subscription = this.reportService.assignRecommendedCoaching(this.rowData.id).subscribe(() => {
      this.reportService.triggerRowsDeleted(this.rowData);
      this.cService.triggerMenuBadgeCountUpdateObservable(navData[this.interventionType].idName);
      subscription.unsubscribe();
    });
  }

  /**
   * Rejects the recommended coaching for this driver.
   */
  public rejectCoaching(): void {
    const subscription = this.reportService.rejectRecommendCoaching(this.rowData.id).subscribe(() => {
      this.reportService.triggerRowsDeleted(this.rowData);
      this.cService.triggerMenuBadgeCountUpdateObservable(navData[this.interventionType].idName);
      subscription.unsubscribe();
    });
  }

  /**
   * Determines whether the component should handle refresh.
   */
  refresh(): boolean {
    return false;
  }
}
